import React from "react";
//import { useState, useEffect } from 'react';
import CheckIsMobile from "./mobile";
import "bootstrap-icons/font/bootstrap-icons.css";

const NavigationTabs = () => {

  let isMobile = CheckIsMobile();
  
  // The gap is not changing in the mobile view in vercel - Check it
  const buttonStyle = {
    display: "flex",
    gap: isMobile ? "30px" : "0px",
    width: isMobile ? "90px" : "200px",
    height: isMobile ? "30px" : "40px",
    backgroundColor: "cyan",
    color: "black",
    fontSize: isMobile ? "0.9rem" : "1.125rem",
    cursor: "pointer",
    padding: isMobile ? "5px 10px" : "10px 15px",
    border: "none",
    borderRadius: isMobile ? "4px" : "8px",
    transition: "background-color 0.3s ease",
    justifyContent: "center",
    gap: isMobile ? "6px" : "8px"
  };

  const NavigationStyle = { 
    width: "100%", 
    backgroundColor: isMobile ? "cyan" : "black", 
    position: isMobile ? "fixed" : "static", 
    bottom : isMobile ? 0 : "auto", 
    top: isMobile ? "auto" : 0, 
    left: 0,
    display: "flex", 
    justifyContent: "space-around", 
    paddingTop: "12px", 
    paddingBottom: "12px"
  }

  return (
    <nav style={ NavigationStyle }>
      {[
        { name: "Home", link: "/", icon: "bi bi-house-door-fill" },
        { name: "About", link: "/about", icon: "bi bi-info-circle-fill" },
        { name: "Services", link: "/services", icon: "bi bi-briefcase-fill" },
        { name: "Applications", link: "/applications", icon: "bi bi-app-indicator" },
        { name: "Contacts", link: "/contact", icon: "bi bi-telephone-fill" }
      ].map((tab, index) => (
        <button key={index} onClick={() => (window.location.href = tab.link)} style={buttonStyle}
        onMouseOver={(e) => (e.target.style.backgroundColor = "lightgray")} // Hover effect
        onMouseOut={(e) => (e.target.style.backgroundColor = "cyan")}>
          <i className={tab.icon} ></i>
          {tab.name}
        </button>
      ))}
    </nav>
  );
};

export default NavigationTabs;
